"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable max-classes-per-file */
//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2014-2017 Flowhub UG
//     NoFlo may be freely distributed under the MIT license
var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var InPort = require('./InPort');

var OutPort = require('./OutPort'); // NoFlo ports collections
//
// Ports collection classes for NoFlo components. These are
// used to hold a set of input or output ports of a component.


var Ports = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Ports, _EventEmitter);

  var _super = _createSuper(Ports);

  function Ports(ports, model) {
    var _this;

    _classCallCheck(this, Ports);

    _this = _super.call(this);
    _this.model = model;
    _this.ports = {};

    if (!ports) {
      return _possibleConstructorReturn(_this);
    }

    Object.keys(ports).forEach(function (name) {
      var options = ports[name];

      _this.add(name, options);
    });
    return _this;
  }

  _createClass(Ports, [{
    key: "add",
    value: function add(name, options, process) {
      if (name === 'add' || name === 'remove') {
        throw new Error('Add and remove are restricted port names');
      }
      /* eslint-disable no-useless-escape */


      if (!name.match(/^[a-z0-9_\.\/]+$/)) {
        throw new Error("Port names can only contain lowercase alphanumeric characters and underscores. '".concat(name, "' not allowed"));
      } // Remove previous implementation


      if (this.ports[name]) {
        this.remove(name);
      }

      if (_typeof(options) === 'object' && options.canAttach) {
        this.ports[name] = options;
      } else {
        var Model = this.model;
        this.ports[name] = new Model(options, process);
      }

      this[name] = this.ports[name];
      this.emit('add', name);
      return this; // chainable
    }
  }, {
    key: "remove",
    value: function remove(name) {
      if (!this.ports[name]) {
        throw new Error("Port ".concat(name, " not defined"));
      }

      delete this.ports[name];
      delete this[name];
      this.emit('remove', name);
      return this; // chainable
    }
  }]);

  return Ports;
}(EventEmitter);

exports.InPorts = /*#__PURE__*/function (_Ports) {
  _inherits(InPorts, _Ports);

  var _super2 = _createSuper(InPorts);

  function InPorts(ports) {
    _classCallCheck(this, InPorts);

    return _super2.call(this, ports, InPort);
  }

  _createClass(InPorts, [{
    key: "on",
    value: function on(name, event, callback) {
      if (!this.ports[name]) {
        throw new Error("Port ".concat(name, " not available"));
      }

      this.ports[name].on(event, callback);
    }
  }, {
    key: "once",
    value: function once(name, event, callback) {
      if (!this.ports[name]) {
        throw new Error("Port ".concat(name, " not available"));
      }

      this.ports[name].once(event, callback);
    }
  }]);

  return InPorts;
}(Ports);

exports.OutPorts = /*#__PURE__*/function (_Ports2) {
  _inherits(OutPorts, _Ports2);

  var _super3 = _createSuper(OutPorts);

  function OutPorts(ports) {
    _classCallCheck(this, OutPorts);

    return _super3.call(this, ports, OutPort);
  }

  _createClass(OutPorts, [{
    key: "connect",
    value: function connect(name, socketId) {
      if (!this.ports[name]) {
        throw new Error("Port ".concat(name, " not available"));
      }

      this.ports[name].connect(socketId);
    }
  }, {
    key: "beginGroup",
    value: function beginGroup(name, group, socketId) {
      if (!this.ports[name]) {
        throw new Error("Port ".concat(name, " not available"));
      }

      this.ports[name].beginGroup(group, socketId);
    }
  }, {
    key: "send",
    value: function send(name, data, socketId) {
      if (!this.ports[name]) {
        throw new Error("Port ".concat(name, " not available"));
      }

      this.ports[name].send(data, socketId);
    }
  }, {
    key: "endGroup",
    value: function endGroup(name, socketId) {
      if (!this.ports[name]) {
        throw new Error("Port ".concat(name, " not available"));
      }

      this.ports[name].endGroup(socketId);
    }
  }, {
    key: "disconnect",
    value: function disconnect(name, socketId) {
      if (!this.ports[name]) {
        throw new Error("Port ".concat(name, " not available"));
      }

      this.ports[name].disconnect(socketId);
    }
  }]);

  return OutPorts;
}(Ports); // Port name normalization:
// returns object containing keys name and index for ports names in
// format `portname` or `portname[index]`.


exports.normalizePortName = function normalizePortName(name) {
  var port = {
    name: name
  }; // Regular port

  if (name.indexOf('[') === -1) {
    return port;
  } // Addressable port with index


  var matched = name.match(/(.*)\[([0-9]+)\]/);

  if (!(matched != null ? matched.length : undefined)) {
    return name;
  }

  return {
    name: matched[1],
    index: matched[2]
  };
};